import { Box, Container } from "@mui/material";
import React, { useState, useEffect } from "react";
import SharedHeader from "../../generic-components/shared-header/SharedHeader";
import FormHeader from "../../screens/registered-user/shared-cost-application/header/FormHeader";
import MyInvestmentAdivceWithNoPlans from "./MyInvestmentAdivceWithNoPlans";
import MyInvestmentAdvicewithPlans from "./MyInvestmentAdvicewithPlans";
import MyInvestmentAdivceWithPlansNoNingi from "./MyInvestmentAdivceWithPlansNoNingi";
import { useLazyQuery } from "@apollo/client";
import { getNingiDetails } from "../../../graphql/queries/getningijourneyDetails";
import { getAVCamount } from "../../../graphql/queries/getAVCamount";
import useStepper from "../../../hooks/useStepper";
import usePlan from "../../../hooks/usePlan";
import Loader from "../../generic-components/loader";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const MyInvestmentAdvice = ({ organisation }) => {
  const [userWithNingiRecommendation, setUserWithNingiRecommendation] =
    useState([]);
  const [AVCamount, setAVCamount] = useState();
  const [isLoad, setIsLoad] = useState(true);

  const { personalDetails } = useStepper();
  const { isLatestActivePlan } = usePlan();

  const [fetchNingiDetails] = useLazyQuery(getNingiDetails, {
    variables: {
      id: personalDetails.id,
      organisation_id: personalDetails.organisation_id,
    },
    onCompleted: (data) => {
      setUserWithNingiRecommendation(data?.ningi_journeys);
      setIsLoad(false);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const [fetchAVCamount] = useLazyQuery(getAVCamount, {
    variables: {
      plan_id: isLatestActivePlan || 0,
    },
    onCompleted: (data) => {
      setAVCamount(data?.plans[0]?.total_avc_amount_requested);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (personalDetails.organisation_id && personalDetails.id) {
      fetchNingiDetails();
    }
  }, [personalDetails.organisation_id, personalDetails.id]);

  useEffect(() => {
    fetchAVCamount();
  }, []);

  return (
    <>
      <Box className="MyIncestmentAdvice-container space-from-top">
        <SharedHeader heading="My Investment Advice" />
        <Container>
          <FormHeader
            heading={organisation?.name}
            amount={isLatestActivePlan ? AVCamount : null}
          />
          <Box className="MyInvestmentAdvice-wrapper">
            <Box className="MyInvestmentAdvice">
              {isLatestActivePlan ? (
                isLoad ? (
                  <Loader />
                ) : !userWithNingiRecommendation ||
                  !userWithNingiRecommendation.length ? (
                  <MyInvestmentAdivceWithPlansNoNingi />
                ) : (
                  <MyInvestmentAdvicewithPlans AVCamount={AVCamount} />
                )
              ) : (
                <MyInvestmentAdivceWithNoPlans />
              )}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    organisation: state?.organisation?.organisation,
  };
};

MyInvestmentAdvice.propTypes = {
  organisation: PropTypes.object,
};

export default connect(mapStateToProps)(MyInvestmentAdvice);
